export const applicationFormDefaults = {
  // Loan details
  loanAmount: "",
  loanPurpose: "",
  loanTerm: "",
  loanId: "",
  assetFound: "",
  assetYear: "",
  assetSeller: "",
  assetAgeEstimate: "",
  requirementsAndObjectives: "",
  additionalInformation: "",
  hasAlias: "",
  aliasFullNames: "",
  requirementAndObjectivesKey: "",
  loanFeatureKeys: [] as string[],
  loanFeatures: "",

  // Applicant details
  title: "",
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: "",
  citizenshipStatus: "",
  maritalStatus: "",
  numberOfFinancialDependents: "",
  email: "",
  mobile: "",

  // Identification
  idenfiticationSource1: "",
  idenfiticationSource2: "",
  driverLicenceNumber: "",
  driverLicenceCardNumber: "",
  driversLicenceState: "",
  driversLicenceExpiry: "",
  medicareCardNumber: "",
  medicareInitial: "",
  medicareColour: "",
  medicareReferenceNumber: "",
  medicareExpiry: "",
  passportNumber: "",
  passportCountry: "",

  // Address
  address: "",
  addressUnit: "",
  addressStreetNumber: "",
  addressStreetName: "",
  addressStreetType: "",
  addressSuburb: "",
  addressState: "",
  addressPostcode: "",
  yearsAtAddress: "",
  monthsAtAddress: "",
  livingSituationAtAddress: "",

  // Living situation
  mortgageFinanceCompany: "",
  mortgageBalance: "",
  mortgageRepaymentAmount: "",
  mortgageRepaymentFrequency: "",
  hasCoBorrower: "",
  totalRentalAmount: "",
  rentalAmountFrequency: "",
  rentShared: [] as string[],
  propertyOwnerManagerName: "",
  propertyOwnerManagerPhone: "",

  // investment property
  ownsInvestmentProperty: "",
  investmentPropertyMortgaged: "",

  // Previous address
  previousAddress: "",
  previousAddressUnit: "",
  previousAddressStreetNumber: "",
  previousAddressStreetName: "",
  previousAddressStreetType: "",
  previousAddressSuburb: "",
  previousAddressState: "",
  previousAddressPostcode: "",
  yearsAtPreviousAddress: "",
  monthsAtPreviousAddress: "",
  livingSituationAtPreviousAddress: "",

  // Employment
  employmentStatus: "",
  yearsAtEmployer: "",
  monthsAtEmployer: "",
  employerName: "",
  occupation: "",
  employmentContactNumber: "",
  employmentIndustry: "",

  // Previous employment
  previousEmploymentStatus: "",
  yearsAtPreviousEmployer: "",
  monthsAtPreviousEmployer: "",
  previousEmployerName: "",
  previousOccupation: "",
  previousEmploymentContactNumber: "",

  // Primary Income
  incomeSource: "",
  incomeAmount: "",
  incomeFrequency: "",

  // Other Income
  hasOtherIncomes: "",

  otherIncomeSource_1: "",
  otherIncomeAmount_1: "",
  otherIncomeFrequency_1: "",

  otherIncomeSource_2: "",
  otherIncomeAmount_2: "",
  otherIncomeFrequency_2: "",

  otherIncomeSource_3: "",
  otherIncomeAmount_3: "",
  otherIncomeFrequency_3: "",

  partnerIncomeAmount: "",
  //spending default is zero
  groceries: "0",
  clothing: "0",
  council_rates: "0",
  car_registration: "0",
  petrol: "0",
  health_insurance: "0",
  car_home_insurance: "0",
  utilities: "0",
  communication: "0",
  transportation: "0",
  education: "0",
  entertainment: "0",
  other_general_expenses: "0",
  other_additional_expenses: "0",
  childSupport: "0",
  land_tax: "0",
  childcare: "0",

  //financial debt
  isDebtPrePopulated: "",
  isDebtPrefillOverridden: "",
  prefilledDebtCount: "",
  hasDebts: "",

  // Credit Sense
  skipCreditSense: [] as string[],
  creditSenseResult: "",
  allowBypassCreditSense: "",

  // bank details

  bankName: "",
  accountName: "",
  bsb: "",
  accountNumber: "",
  jointAccount: [] as string[],
  jointAccountName: "",

  significantPlannedChanges: "",
  significantPlannedChangeTypes: [] as string[],

  termsAndConditionsAgreement: [] as string[],

  // Other
  userType: "",
  requestSecuredRate: "",
  page: "",
  offerId: "",
  partnerCompanyId: "",
};

export enum PaymentFrequency {
  ANNUAL = "annual",
  MONTHLY = "monthly",
  FORTNIGHTLY = "fortnightly",
  WEEKLY = "weekly",
}

export const paymentFrequencyOptions = [
  { label: "Monthly", value: PaymentFrequency.MONTHLY },
  { label: "Weekly", value: PaymentFrequency.WEEKLY },
  { label: "Fortnightly", value: PaymentFrequency.FORTNIGHTLY },
  { label: "Annual", value: PaymentFrequency.ANNUAL },
];

export const emptyCurrencyValues = ["0", ""];

export const validPhoneNumberRegex =
  /^(02|03|04|07|08|13|18)\d{2} \d{3} \d{3}$/;

export const validMobileNumberRegex = /^(?!0400 000 000)04\d{2} \d{3} \d{3}$/;

export const FORM_ERROR_TITLE = "Form errors";
export const UNEXPECTED_ERROR_TITLE = "Unexpected error";
